import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import React from "react";
import styles from "./styles.css";
import { friendlyResultsTitle, renderFriendlyFinds, renderComponentByIndex, calculateLastRowEmptySlots } from "./utils.js";
function ProductResults(_ref) {
  var _context;
  var products = _ref.products,
    friendlyFindsProducts = _ref.friendlyFindsProducts,
    layoutProps = _ref.layoutProps,
    modalComponent = _ref.modalComponent,
    modalEntryPoint = _ref.modalEntryPoint,
    modalCtaUrl = _ref.modalCtaUrl,
    favoriteComponent = _ref.favoriteComponent,
    instagramGalleryComponent = _ref.instagramGalleryComponent,
    localVendorsComponent = _ref.localVendorsComponent,
    topPickCollection = _ref.topPickCollection,
    articlesComponent = _ref.articlesComponent,
    retakeBannerComponent = _ref.retakeBannerComponent,
    retakeBannerIndexDesktop = _ref.retakeBannerIndexDesktop,
    retakeBannerIndexMobile = _ref.retakeBannerIndexMobile;
  var lastRowEmptySlots = calculateLastRowEmptySlots(layoutProps, products.length);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    role: "grid",
    className: styles["fashion-result--container"]
  }, _mapInstanceProperty(products).call(products, function (product, index) {
    return renderComponentByIndex(index, product, layoutProps, modalComponent, modalEntryPoint, modalCtaUrl, favoriteComponent, instagramGalleryComponent, localVendorsComponent, topPickCollection, articlesComponent, retakeBannerComponent, retakeBannerIndexDesktop, retakeBannerIndexMobile);
  })), friendlyFindsProducts && friendlyFindsProducts.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    className: styles["fashion-friendly-results--title"]
  }, friendlyResultsTitle()), /*#__PURE__*/React.createElement("section", {
    role: "grid",
    className: styles["fashion-friendly-results--container"]
  }, _mapInstanceProperty(_context = _sliceInstanceProperty(friendlyFindsProducts).call(friendlyFindsProducts, 0, friendlyFindsProducts.length - lastRowEmptySlots)).call(_context, function (product, index) {
    return renderFriendlyFinds(index, product, layoutProps, products.length, lastRowEmptySlots);
  }))));
}
export default ProductResults;